import { AllSystemProps, allSystemProps } from 'shared/styles/props';

import styled from '@emotion/styled';

export interface BoxProps extends AllSystemProps {
  className?: string;
  style?: React.CSSProperties;
}

export const IconButton = styled('button')<BoxProps>(
  {
    border: 0,
    padding: 0,
    background: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:disabled': {
      opacity: '0.5',
    },
  },
  allSystemProps
);
